import React from 'react';
import { styled } from 'baseui';
import type { CompletedAnnotationT, ReviewAnnotationT } from '../types';
import { CompletedCard } from './completed-card';
type Props = {
  annotations: (ReviewAnnotationT & CompletedAnnotationT)[];
  selectAnnotation?: (annotationId: string) => void;
};
const Container = styled('div', ({
  $theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: $theme.sizing.scale500,
  height: '100%',
  overflow: 'auto'
}));
export const CardList = ({
  annotations,
  selectAnnotation
}: Props) => {
  return <Container>
      {annotations.map((annotation, index) => <CompletedCard key={index} annotation={annotation} selectAnnotation={selectAnnotation} />)}
    </Container>;
};